/* eslint-disable react/prop-types */

import React from 'react';
import { Form } from 'react-bootstrap';

const ErrorFeedback = ({ error }) =>
  error && (
    <Form.Control.Feedback style={{ display: 'block' }} type="invalid">
      {error.message}
    </Form.Control.Feedback>
  );

export default ErrorFeedback;
